var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIconAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5199 34.9959C34.3665 34.9959 38.3079 31.0545 38.3079 26.2079C38.3079 21.3613 34.3665 17.4199 29.5199 17.4199C24.6734 17.4199 20.7319 21.3613 20.7319 26.2079C20.7319 31.0545 24.6734 34.9959 29.5199 34.9959ZM29.5199 21.8139C31.9432 21.8139 33.9139 23.7846 33.9139 26.2079C33.9139 28.6312 31.9432 30.6019 29.5199 30.6019C27.0966 30.6019 25.1259 28.6312 25.1259 26.2079C25.1259 23.7846 27.0966 21.8139 29.5199 21.8139Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2458 52.1632C28.6179 52.4281 29.0633 52.5705 29.52 52.5705C29.9768 52.5705 30.4222 52.4281 30.7943 52.1632C31.4622 51.6908 47.1598 40.3565 47.096 26.2078C47.096 16.5169 39.211 8.63184 29.52 8.63184C19.8291 8.63184 11.944 16.5169 11.944 26.1968C11.8803 40.3565 27.5779 51.6908 28.2458 52.1632ZM29.52 13.0258C36.7899 13.0258 42.702 18.938 42.702 26.2188C42.7482 35.9691 33.0616 44.7242 29.52 47.5956C25.9807 44.722 16.2919 35.9647 16.338 26.2078C16.338 18.938 22.2502 13.0258 29.52 13.0258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconAb);
export default __webpack_public_path__ + "static/media/locationIcon_ab.0badf29be60c7d49a04e29f9f10c6ca0.svg";
export { ForwardRef as ReactComponent };